const BASE_URL = '/api/v2'

const toUrlParams = (params: Record<string, any>) => {
  return new URLSearchParams(params).toString()
}

const myFetch = async <T = any>(url: string, options: RequestInit = {}): Promise<T> => {
  const defaultOptions: RequestInit = {
    credentials: 'include',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      lang: localStorage.lang,
      ...options.headers,
    },
  }

  const mergedOptions: RequestInit = {
    ...defaultOptions,
    ...options,
  }

  // 根据Content-Type处理请求体
  if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(mergedOptions.method || '')) {
    const headers = new Headers(mergedOptions.headers)
    const contentType = headers.get('Content-Type')

    // 仅当Content-Type为JSON时转换请求体
    if (contentType === 'application/json' && mergedOptions.body && typeof mergedOptions.body === 'object') {
      mergedOptions.body = JSON.stringify(mergedOptions.body)
    }
  }

  try {
    const response = await fetch(`${BASE_URL}${url}`, mergedOptions)

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    return response.json()
  } catch (error) {
    console.error('Fetch error:', error)
    throw error
  }
}

// 封装请求方法
export const get =
  <T = any>(url: string) =>
  (params?: Record<string, any>) => {
    const query = params ? `?${toUrlParams(params)}` : ''
    return myFetch<T>(`${url}${query}`, { method: 'GET' })
  }

export const post1 =
  <T = any>(url: string) =>
  (body?: Record<string, any>) => {
    return myFetch<T>(url, {
      method: 'POST',
      body: JSON.stringify(body),
    })
  }

// 修改POST方法使用FormData格式
export const post =
  <T = any>(url: string) =>
  (body?: Record<string, any>) => {
    const formData = body ? new URLSearchParams(body) : undefined
    return myFetch<T>(url, {
      method: 'POST',
      body: formData?.toString(),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // 设置表单格式
      },
    })
  }
